<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { buildCancelReplanPropertyTag } from "../../../../../../../../_logic/cancel-replan-presentation"
  import type {
    CancelReplanRow,
    CancelReplanUnitContactContext,
  } from "../../../../../../../../_logic/cancel-replan-contract"
  import {
    appendPlanningContactSubLabel,
    planningContactsTooltipList,
    planningUnitContactContextKey,
    planningUnitContactContextMap,
  } from "../../../../../../../../../../../_shared/_logic/planning-contact-contexts"
  import {
    RICH_TOOLTIP_CLASS,
    buildRichTooltip,
    tooltipField,
    tooltipTitle,
  } from "../../../../../../../../../../../../../_shared/_logic/rich-tooltips"

  let {
    row,
    unitContactContexts = [],
  }: {
    row: CancelReplanRow
    unitContactContexts?: CancelReplanUnitContactContext[]
  } = $props()

  const tag = $derived(buildCancelReplanPropertyTag(row))
  const contextByKey = $derived(planningUnitContactContextMap(unitContactContexts))
  const contactContext = $derived(
    contextByKey.get(
      planningUnitContactContextKey(row.workOrder?.property_id, row.workOrder?.property_unit_id),
    ) ?? null,
  )
  const subLabel = $derived(appendPlanningContactSubLabel(tag.subLabel, contactContext))
  const richTooltip = $derived(
    buildRichTooltip([
      tooltipTitle("Liegenschaft"),
      tooltipField("Adresse", tag.label),
      tooltipField("Einheit", tag.subLabel),
      planningContactsTooltipList(contactContext),
    ]),
  )
</script>

<StatusTag
  variant="neutral"
  size="sm"
  label={tag.label}
  subLabel={subLabel ?? undefined}
  color={tag.color}
  icon={tag.icon}
  tooltipContent={row.property ? richTooltip : "Liegenschaft konnte nicht geladen werden."}
  tooltipHtml={Boolean(row.property)}
  tooltipClassName={row.property ? RICH_TOOLTIP_CLASS : ""}
  disableTitle={true}
/>
